module.exports = __webpack_public_path__ + "img/Payment-Success.0a539c1f.jpg";